import { render } from "./TandartsLiempde.vue?vue&type=template&id=548bb81c&scoped=true"
import script from "./TandartsLiempde.vue?vue&type=script&lang=js"
export * from "./TandartsLiempde.vue?vue&type=script&lang=js"

import "./TandartsLiempde.vue?vue&type=style&index=0&id=548bb81c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\mraha\\Pictures\\tandzorggestel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-548bb81c"]])

export default __exports__